import { writable } from 'svelte/store';

export const recipientsStore = writable({});
